// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.General_General__s2eq7 {
  background: #F0F2F5;
  padding: 24px;
  height: 68vh;
}
.General_General__s2eq7 .General_content__7ghax {
  width: 100%;
  background: #ffffff;
  padding: 24px;
  min-height: 100%;
  height: max-content;
}
.General_General__s2eq7 .General_content__7ghax .General_tabTitle__X0GoT {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.General_General__s2eq7 .General_content__7ghax .General_fieldsWrapper__RKIgc {
  display: flex;
  gap: 16px;
}
.General_General__s2eq7 .General_content__7ghax .General_fieldsWrapper__RKIgc .General_field__LCTHc {
  max-width: 49%;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/General/General.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;AACF;AAAE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AADI;EACE,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;AAEN;AACI;EACE,aAAA;EACA,SAAA;AACN;AACM;EACE,cAAA;EACA,SAAA;AACR","sourcesContent":[".General {\n  background: #F0F2F5;\n  padding: 24px;\n  height: 68vh;\n  .content {\n    width: 100%;\n    background: #ffffff;\n    padding: 24px;\n    min-height: 100%;\n    height: max-content;\n    .tabTitle {\n      margin-bottom: 16px;\n\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 24px\n    }\n\n    .fieldsWrapper {\n      display: flex;\n      gap: 16px;\n\n      .field {\n        max-width: 49%;\n        flex: 1 1;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"General": `General_General__s2eq7`,
	"content": `General_content__7ghax`,
	"tabTitle": `General_tabTitle__X0GoT`,
	"fieldsWrapper": `General_fieldsWrapper__RKIgc`,
	"field": `General_field__LCTHc`
};
export default ___CSS_LOADER_EXPORT___;
